export default {
  id: 11,
  title: 'Target #11 - Eye of Sauron',
  url: 'https://cssbattle.dev/play/11',
  colors: ['#191210', '#ECA03D', '#84271C'],
  solution:
    '<a a><a b><a c><style>body{background:#191210}a{position:fixed;border-radius:50%;border:20px solid #ECA03D}a[a],a[b]{width:60;height:60;border-top-color:transparent;border-left-color:transparent;transform:rotate(45deg)}a[a]{top:100;left:50}a[b]{transform:rotate(225deg);top:100;right:50}a[c]{width:100;height:100;top:80;left:130  }a[c]::after{content:"";position:fixed;top:125;left:175;width:50;height:50;border-radius:50%;background:#84271C}</style>',
}
